/**
 * Skeleton Cart Button Component
 *
 * Lightweight skeleton for the floating cart button.
 * Shows instantly while the full cart drawer loads.
 *
 * @element skeleton-cart-button
 *
 * @example
 * ```html
 * <skeleton-cart-button></skeleton-cart-button>
 * ```
 */

import { LitElement, html } from "lit";
import { customElement } from "lit/decorators.js";

@customElement("skeleton-cart-button")
export class SkeletonCartButton extends LitElement {
  /**
   * Render in light DOM to enable Tailwind CSS classes
   */
  createRenderRoot() {
    return this;
  }

  render() {
    return html`
      <div
        class="absolute top-4 right-4 z-40"
        role="button"
        aria-label="Loading cart"
      >
        <div class="bg-border w-12 h-12 rounded-full shadow-lg"></div>
      </div>
    `;
  }
}
